import { HStack, Checkbox, CheckboxGroup, Stack, Text } from '@chakra-ui/react'

import { FormItem } from 'components'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'

export default function DefaultValueMultipleSelection({ formMethods, question }: DefaultValueCommonProps) {
  useUnregisterDefaultValueField({ formMethods })

  return (
    <FormItem label="Valor inicial">
      {question?.options && question?.options?.length > 0 ? (
        <CheckboxGroup
          size="md"
          defaultValue={question.default_value}
          onChange={(values: string[]) => formMethods.setValue('default_value', values)}
        >
          <Stack>
            {question?.options?.map((option) => {
              if (option === 'Outro') return null
              return (
                <HStack key={option}>
                  <Checkbox borderColor="borderColor" value={option} />
                  <Text>{option}</Text>
                </HStack>
              )
            })}
          </Stack>
        </CheckboxGroup>
      ) : (
        <Text variant="noData">Nenhuma opção disponível</Text>
      )}
    </FormItem>
  )
}
